import { windowSize } from "./../windowSize";
import { gsap } from "gsap";
import { Global } from "./../global";
// import { easeOutExpo, easeInOutExpo, easeOutQuart,easeInOutQuart,easeInOutQuad } from 'easing-utils';
// import {easeOutQuart} from 'easing-utils';
import { Ease } from "./../_ease/ease";

export const HeadSnowAni = {
  xAxis:0,
  yAxis:0,
  unit:20,
  amp:0,
  drawin:{},
  timer:null,
  inc:0,
  incConst:0.01,
  setCanvas:()=>{
    HeadSnowAni.Colors=[]
    HeadSnowAni.Length=null;
    HeadSnowAni.isMove=[]
    HeadSnowAni.CNV=[]
    HeadSnowAni.CONT=[]
    HeadSnowAni.Section=[]
    
    HeadSnowAni.headCnvBox=document.querySelectorAll('.js-headCnvBox')
    HeadSnowAni.headCnvBox.forEach(function(item,i){
      let C = document.createElement("canvas");
      item.appendChild(C)
      HeadSnowAni.Colors.push(item.dataset.color)
      HeadSnowAni.Section.push(item.dataset.section)
      HeadSnowAni.CNV.push(item.children[0])
      HeadSnowAni.CONT.push(item.children[0].getContext("2d"))
      item.children[0].width=item.clientWidth;
      item.children[0].height=item.clientHeight;
      HeadSnowAni.isMove.push(true);
      HeadSnowAni.drawWhite(i)
    })
    HeadSnowAni.incConst=Global.isMobile ? 0.01 : 0.01;
    HeadSnowAni.incConst=0.01;
    gsap.set(".is-headContainer span",{autoAlpha:1})
  },
  ready:(i)=>{
    if(Global.isHeadAnimaEnd){
      Global.isHeadAnimaEnd=false;
      HeadSnowAni.reset(i)
      HeadSnowAni.moveOut(i)
      HeadSnowAni.draw(i)
    }
  },
  reset:(i)=>{
    HeadSnowAni.xAxis = Math.floor(HeadSnowAni.CNV[i].height/4);
    HeadSnowAni.amp=0
    HeadSnowAni.yAxis = 0;
    HeadSnowAni.drawin.t=0;
    HeadSnowAni.drawin.seconds=0;
    HeadSnowAni.inc=0
  },
  moveOut:(i)=>{
    let time=4400;
    let start=null;
    let ease = Ease.getEase("easeOutExpo");
    let progress = 0;
    let easeProgress = 0;

    let update = (timestamp) => {
      if(!start) start = timestamp;
      progress = (timestamp - start) / time;
      progress = Math.min(progress, 1);

      if (progress >= 0) {
        easeProgress = ease(progress, 0, 1, 1); // 進捗率からイージング関数を通した変化割合を算出
      }
      // HeadSnowAni.amp = 25*(1-Math.cos(2*progress));
      HeadSnowAni.amp = 25*(1-easeProgress);
      
      HeadSnowAni.inc = (HeadSnowAni.CNV[i].height+40)*easeProgress;
      if (progress < 1) {
        HeadSnowAni.reqOut=requestAnimationFrame(update);
      }

      if(easeProgress>=0.3) {
        if(HeadSnowAni.Section[i]=="news"){
          document.querySelector('.is-moon').classList.add('is-active')
        }
      }

      if(easeProgress>=0.8){
        cancelAnimationFrame(HeadSnowAni.reqOut)
        clearTimeout(HeadSnowAni.timer)
        Global.isHeadAnimaEnd=true;
        // alert('終わりだ')
      } 
    }
    let go =()=>{
      start=null;
      HeadSnowAni.reqOut=requestAnimationFrame(update);
    }
    go()
  },
  // moveOut:(i)=>{
  //   let C=0.0;
  //   let m=setInterval(()=>{
  //     C += HeadSnowAni.incConst;
  //     C = Math.min(1, C);
  //     // 収束
  //     HeadSnowAni.amp = 15*(1-C);
  //     HeadSnowAni.inc = (HeadSnowAni.CNV[i].height)*easeOutQuart(C);

  //     if(C>=0.5) {
  //       clearInterval(m);
  //       clearTimeout(HeadSnowAni.timer)
  //       Global.isHeadAnimaEnd=true;
  //       console.log('終わりだ')
  //     }
  //     // if(C>=1) {
  //     //   // clearInterval(m);
  //     //   // clearTimeout(HeadSnowAni.timer)
  //     //   // Global.isHeadAnimaEnd=true;
  //     // }
  //     if(C>=0.2) {
  //       if(HeadSnowAni.Section[i]=="news"){
  //         document.querySelector('.is-moon').classList.add('is-active')
  //       }
  //     }
  //   },22)
  // },
  draw:(i)=>{
    HeadSnowAni.clear(i)
    HeadSnowAni.drawWave(i, 2.2);
    HeadSnowAni.drawin.seconds = HeadSnowAni.drawin.seconds + 0.004;
    HeadSnowAni.drawin.t = HeadSnowAni.drawin.seconds*Math.PI;

    HeadSnowAni.timer = setTimeout(()=>{
      HeadSnowAni.draw(i)
    }, 35) // 28
    
  },
  drawWave:(i, zoom)=>{
    HeadSnowAni.design(i)
    //パスの開始
    HeadSnowAni.CONT[i].beginPath(); 

    HeadSnowAni.drawWaveOut(i,zoom);
    
    // wave complete
    HeadSnowAni.CONT[i].closePath() //パスを閉じる
    HeadSnowAni.CONT[i].fill(); //塗りつぶす
  },
  design:(i)=>{
    HeadSnowAni.CONT[i].fillStyle = HeadSnowAni.Colors[i];
  },
  drawWaveOut:(c_idx,zoom)=>{
    let T=HeadSnowAni.drawin.t;
    let x = T / 0.5; //時間を横の位置とする
    for (let i = 0,li=HeadSnowAni.CNV[c_idx].width+10; i <= li; i += 10) {
      // x = T+(-HeadSnowAni.yAxis+i)/100/zoom;
      x = T+i/50/zoom;
      // y = HeadSnowAni.amp*Math.sin(x);

      HeadSnowAni.CONT[c_idx].lineTo(i, HeadSnowAni.amp*Math.sin(x)+HeadSnowAni.inc);
    }
    HeadSnowAni.CONT[c_idx].lineTo(HeadSnowAni.CNV[c_idx].width + 10, HeadSnowAni.CNV[c_idx].height);
    HeadSnowAni.CONT[c_idx].lineTo(0, HeadSnowAni.CNV[c_idx].height); 
  },
  clear:(i)=>{
    HeadSnowAni.CONT[i].clearRect(0, 0, HeadSnowAni.CNV[i].width, HeadSnowAni.CNV[i].height);
  },
  setCanvasSize: (i)=>{
    HeadSnowAni.CNV[i].width=windowSize.clientSize().W;
    HeadSnowAni.CNV[i].height=windowSize.clientSize().H;
  },
  drawWhite:()=>{
    for(let i=0,li=HeadSnowAni.CNV.length;i<li;i++){
      HeadSnowAni.clear(i);
      HeadSnowAni.design(i)
      HeadSnowAni.CONT[i].beginPath(); 
      HeadSnowAni.CONT[i].lineTo(0, 0);
      HeadSnowAni.CONT[i].lineTo(HeadSnowAni.CNV[i].width + 10, 0);
      HeadSnowAni.CONT[i].lineTo(HeadSnowAni.CNV[i].width + 10, HeadSnowAni.CNV[i].height);
      HeadSnowAni.CONT[i].lineTo(0, HeadSnowAni.CNV[i].height)
      HeadSnowAni.CONT[i].closePath()
      HeadSnowAni.CONT[i].fill();
    }
  },
  resize:()=>{
    let setTimeoutId = null;
    window.addEventListener("resize", e => {
      if (setTimeoutId) clearTimeout(setTimeoutId);
      setTimeoutId = setTimeout(() => {
        for(let i=0,li=HeadSnowAni.CNV.length;i<li;i++){
          HeadSnowAni.setCanvasSize(i)
        }
        setTimeoutId = null;
      }, 50);
    });
  },
};
